(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["idole-balloon-printing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('idole-balloon-printing')) {
    const drafts = new Map();
    customElements.define('idole-balloon-printing', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.form = this.closest('form');
        this.input = this.querySelector('input');
        this.field = this.querySelector('[data-printing-field]');
        this.error = this.querySelector('[data-printing-error]');
        this.variants = JSON.parse(this.querySelector('[data-printing-variants]').textContent);
        this.input.value = drafts.get(this.dataset.product) || '';
        const signal = this.controller.signal;
        this.input.addEventListener('input', () => {
          drafts.set(this.dataset.product, this.input.value);
          this.validate(false);
        }, {signal});
        this.form.addEventListener('change', () => {
          this.sync();
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.sync(), 600);
        }, {signal});
        document.addEventListener('variant:change', event => {
          if (event.detail?.variant && this.variants.some(v => v.id === event.detail.variant.id)) this.sync(event.detail.variant);
        }, {signal});
        this.form.addEventListener('submit', event => {
          this.sync();
          if (!this.validate(true)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.input.focus();
            this.input.reportValidity();
          } else if (!this.input.disabled) {
            this.input.value = this.input.value.trim().replace(/\s+/gu, ' ');
          }
        }, {capture:true,signal});
        this.sync();
      }
      disconnectedCallback() { this.controller?.abort(); clearTimeout(this.timer); }
      sync(variant) {
        const id = Number(this.form.elements.namedItem('id')?.value);
        variant = variant || this.variants.find(v => v.id === id);
        const active = this.dataset.included === 'true' || (variant?.options || []).some(value => value === 'Yes (+$10)');
        this.field.hidden = !active;
        this.input.disabled = !active;
        this.input.required = active;
        if (!active) { this.input.setCustomValidity(''); this.error.textContent = ''; }
        else this.validate(false);
      }
      validate(show) {
        const text = this.input.value.trim();
        const valid = this.input.disabled || (text.length > 0 && text.split(/\s+/u).length <= 3);
        this.input.setCustomValidity(valid ? '' : this.dataset.error);
        this.input.setAttribute('aria-invalid', String(!valid && (show || text.length > 0)));
        this.error.textContent = !valid && (show || text.length > 0) ? this.dataset.error : '';
        return valid;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["idole-delivery-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('idole-delivery-selector')) {
    class IdoleDeliverySelector extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;

        this.abortController = new AbortController();
        this.form = this.closest('form');
        this.dateInput = this.querySelector('input[type="date"]');
        this.timeInput = this.querySelector('select');
        this.timeOptions = Array.from(this.timeInput?.querySelectorAll('option[data-start-minutes]') || []);
        this.note = this.querySelector('.idole-delivery-selector__note');
        this.status = this.querySelector('[role="status"]');
        this.leadDays = Number.parseInt(this.dataset.leadDays, 10) || 0;
        this.saveQueue = Promise.resolve();
        this.changeVersion = 0;

        if (!this.form || !this.dateInput || !this.timeInput) return;

        this.refreshAvailability();
        this.dateInput.addEventListener('change', () => {
          this.refreshAvailability();
          this.queueSave();
        }, { signal: this.abortController.signal });
        this.timeInput.addEventListener('change', () => this.queueSave(), { signal: this.abortController.signal });
        this.form.addEventListener('submit', (event) => this.handleSubmit(event), { signal: this.abortController.signal });

        this.updateCheckoutState(false);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }

      get checkoutButtons() {
        return Array.from(this.form.querySelectorAll('[name="checkout"]'));
      }

      getBeirutNow() {
        const parts = Object.fromEntries(
          new Intl.DateTimeFormat('en-CA', {
            timeZone: 'Asia/Beirut',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23'
          })
            .formatToParts(new Date())
            .filter((part) => part.type !== 'literal')
            .map((part) => [part.type, part.value])
        );
        const hour = Number.parseInt(parts.hour, 10) % 24;
        const minute = Number.parseInt(parts.minute, 10);

        return {
          date: `${parts.year}-${parts.month}-${parts.day}`,
          minutes: (hour * 60) + minute
        };
      }

      addDays(dateString, days) {
        const [year, month, day] = dateString.split('-').map(Number);
        const date = new Date(Date.UTC(year, month - 1, day + days));
        return date.toISOString().slice(0, 10);
      }

      refreshAvailability() {
        const now = this.getBeirutNow();
        let effectiveLeadDays = this.leadDays;

        if (effectiveLeadDays === 0 && now.minutes >= 1080) {
          effectiveLeadDays = 1;
        }

        if (effectiveLeadDays === 0 && this.dataset.noSundaySameDay === 'true' && new Date(`${now.date}T12:00:00Z`).getUTCDay() === 0) {
          effectiveLeadDays = 1;
        }

        const minDate = this.addDays(now.date, effectiveLeadDays);
        this.dataset.minDate = minDate;
        this.dateInput.min = minDate;

        if (this.dateInput.value && this.dateInput.value < minDate) {
          this.dateInput.value = '';
        }

        const isSameDay = this.dateInput.value === now.date;
        this.timeOptions.forEach((option) => {
          const startMinutes = Number.parseInt(option.dataset.startMinutes, 10);
          const unavailable = isSameDay && startMinutes <= now.minutes;
          option.hidden = unavailable;
          option.disabled = unavailable;
        });

        const selectedTime = this.timeInput.selectedOptions[0];
        if (selectedTime?.disabled) {
          this.timeInput.value = '';
        }

        if (this.note && this.leadDays === 0) {
          this.note.textContent = effectiveLeadDays === 0
            ? this.dataset.sameDayMessage
            : this.dataset.leadDayMessage;
        }
      }

      isComplete() {
        this.refreshAvailability();
        const hasDate = Boolean(this.dateInput.value);
        const dateIsAllowed = hasDate && this.dateInput.value >= this.dataset.minDate;
        const hasTime = Boolean(this.timeInput.value) && !this.timeInput.selectedOptions[0]?.disabled;

        this.dateInput.setAttribute('aria-invalid', String(!dateIsAllowed));
        this.timeInput.setAttribute('aria-invalid', String(!hasTime));
        return dateIsAllowed && hasTime;
      }

      setCheckoutDisabled(disabled) {
        this.checkoutButtons.forEach((button) => {
          button.disabled = disabled;
          button.setAttribute('aria-disabled', String(disabled));
        });
      }

      setStatus(message, state = '') {
        this.status.textContent = message;
        this.status.dataset.state = state;
      }

      updateCheckoutState(showMessage) {
        const complete = this.isComplete();
        this.setCheckoutDisabled(!complete);

        if (!complete && showMessage) {
          this.setStatus(this.dataset.requiredMessage, 'error');
        } else if (!showMessage && this.status.dataset.state === 'error') {
          this.setStatus('');
        }

        return complete;
      }

      queueSave() {
        const version = ++this.changeVersion;
        this.setCheckoutDisabled(true);
        this.setStatus(this.dataset.savingMessage);

        this.saveQueue = this.saveQueue
          .catch(() => undefined)
          .then(() => this.saveCurrentValues())
          .then(() => {
            if (version !== this.changeVersion) return;
            const complete = this.updateCheckoutState(true);
            if (complete) this.setStatus(this.dataset.savedMessage);
          })
          .catch(() => {
            if (version !== this.changeVersion) return;
            this.setCheckoutDisabled(true);
            this.setStatus(this.dataset.saveErrorMessage, 'error');
          });
      }

      async saveCurrentValues() {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'Delivery date': this.dateInput.value,
              'Delivery time': this.timeInput.value
            }
          })
        });

        if (!response.ok) throw new Error('Unable to save delivery details');
      }

      handleSubmit(event) {
        if (event.submitter?.name !== 'checkout') return;
        if (this.updateCheckoutState(true)) return;

        event.preventDefault();
        (this.dateInput.value ? this.timeInput : this.dateInput).focus();
      }
    }

    customElements.define('idole-delivery-selector', IdoleDeliverySelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["idole-desk-name-plate-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('idole-desk-name-plate-options')) {
    const idoleDeskNamePlateState = new Map();

    customElements.define('idole-desk-name-plate-options', class extends HTMLElement {
      connectedCallback() {
        const state = idoleDeskNamePlateState.get(this.dataset.formId);
        this.logoInput = this.querySelector('[data-desk-logo]');
        this.logoStatus = this.querySelector('[data-logo-status]');

        if (state) {
          this.querySelectorAll('input[type="text"], textarea').forEach((field) => {
            if (Object.hasOwn(state.fields, field.name)) field.value = state.fields[field.name];
          });
          this.querySelectorAll('input[type="radio"]').forEach((field) => {
            field.checked = state.preview === field.value;
          });
          if (state.logo && this.logoInput) {
            try {
              const transfer = new DataTransfer();
              transfer.items.add(state.logo);
              this.logoInput.files = transfer.files;
            } catch (error) {
              this.logoStatus.textContent = this.dataset.logoNone;
            }
          }
        }

        this.updateLogoStatus();
        this.addEventListener('input', this.captureState);
        this.addEventListener('change', this.handleChange);
      }

      disconnectedCallback() {
        this.captureState();
        this.removeEventListener('input', this.captureState);
        this.removeEventListener('change', this.handleChange);
      }

      handleChange = () => {
        this.updateLogoStatus();
        this.captureState();
      };

      updateLogoStatus = () => {
        const file = this.logoInput?.files?.[0];
        if (!this.logoInput || !this.logoStatus) return;
        let error = '';
        if (file && !/\.(png|jpe?g)$/i.test(file.name)) error = this.dataset.logoInvalid;
        else if (file && file.size > 10 * 1024 * 1024) error = this.dataset.logoTooLarge;
        this.logoInput.setCustomValidity(error);
        this.logoStatus.textContent = error || file?.name || this.dataset.logoNone;
      };

      captureState = () => {
        const fields = {};
        this.querySelectorAll('input[type="text"], textarea').forEach((field) => {
          fields[field.name] = field.value;
        });

        idoleDeskNamePlateState.set(this.dataset.formId, {
          fields,
          preview: this.querySelector('input[type="radio"]:checked')?.value || '',
          logo: this.logoInput?.files?.[0] || null
        });
      };
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["idole-order-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('idole-order-details')) {
    class IdoleOrderDetails extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;

        this.abortController = new AbortController();
        this.form = this.closest('form');
        this.destinationGroup = this.querySelector('[data-destination-group]');
        this.destinationInputs = Array.from(this.querySelectorAll('input[name="attributes[Delivery destination]"]'));
        this.deliverySection = this.querySelector('[data-delivery-section]');
        this.dateInput = this.querySelector('input[name="attributes[Delivery date]"]');
        this.timeInput = this.querySelector('select[name="attributes[Delivery time]"]');
        this.timeOptions = Array.from(this.timeInput?.querySelectorAll('option[data-start-minutes]') || []);
        this.deliveryNote = this.querySelector('[data-delivery-note]');
        this.availabilityTitle = this.querySelector('[data-availability-title]');
        this.availabilityHelp = this.querySelector('[data-availability-help]');
        this.giftToggle = this.querySelector('[data-gift-toggle]');
        this.giftValue = this.querySelector('[data-gift-value]');
        this.giftFields = this.querySelector('[data-gift-fields]');
        this.receiverInput = this.querySelector('input[name="attributes[Receiver name]"]');
        this.senderInput = this.querySelector('input[name="attributes[Sender name]"]');
        this.messageInput = this.querySelector('textarea[name="attributes[Gift message]"]');
        this.status = this.querySelector('[role="status"]');
        this.disclosure = this.closest('[data-idole-order-details-disclosure]');
        this.disclosureState = this.disclosure?.querySelector('[data-idole-order-details-summary-state]');
        this.leadDays = Number.parseInt(this.dataset.leadDays, 10) || 0;
        this.saveQueue = Promise.resolve();
        this.changeVersion = 0;
        this.isSaving = false;

        if (!this.form || !this.destinationInputs.length || !this.dateInput || !this.timeInput || !this.giftToggle) return;

        if (this.dataset.approvalPending === 'true') { this.dateInput.required = false; this.timeInput.required = false; }
        this.initCalendar();
        this.refreshState();
        this.destinationInputs.forEach((input) => {
          input.addEventListener('change', () => {
            this.refreshState();
            this.queueSave();
          }, { signal: this.abortController.signal });
        });
        this.giftToggle.addEventListener('click', () => {
          this.giftToggle.setAttribute('aria-checked', String(!this.isGift));
          this.refreshState();
          this.queueSave();
        }, { signal: this.abortController.signal });
        this.dateInput.addEventListener('change', () => {
          this.refreshAvailability();
          this.queueSave();
        }, { signal: this.abortController.signal });
        this.timeInput.addEventListener('change', () => this.queueSave(), { signal: this.abortController.signal });
        [this.receiverInput, this.senderInput, this.messageInput].forEach((input) => {
          input.addEventListener('input', () => this.updateCheckoutState(false), { signal: this.abortController.signal });
          input.addEventListener('change', () => this.queueSave(), { signal: this.abortController.signal });
        });
        this.form.addEventListener('submit', (event) => this.handleSubmit(event), { capture: true, signal: this.abortController.signal });

        const isInitiallyComplete = this.updateCheckoutState(false);
        if (this.disclosure) this.disclosure.open = !isInitiallyComplete;

        if (this.dataset.productForm === 'true') {
          this.buttonObserver = new MutationObserver(() => {
            if (!this.isComplete()) this.setCheckoutDisabled(true);
          });
          this.buttonObserver.observe(this.form, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
        }

        const hasStaleDestination = this.destination === 'Lebanon' && this.dataset.initialDestination === 'International';
        const hasStaleGiftDetails = !this.isGift && Boolean(this.receiverInput.value || this.senderInput.value || this.messageInput.value);
        if (hasStaleDestination || hasStaleGiftDetails || this.dataset.approvalPending === 'true') this.queueSave();
      }


      initCalendar() {
        this.calendarTrigger = this.querySelector('[data-calendar-trigger]');
        this.calendar = this.querySelector('[data-calendar]');
        if (!this.calendarTrigger || !this.calendar) return;
        this.dateInput.hidden = true;
        this.dateInput.required = false;
        this.calendarTrigger.hidden = false;
        this.calendarTrigger.setAttribute('aria-label', 'Delivery date: Select a date');
        this.querySelector('label[for="' + this.dateInput.id + '"]').htmlFor = this.dateInput.id + '-trigger';
        this.calendarTrigger.id = this.dateInput.id + '-trigger';
        const signal = this.abortController.signal;
        this.calendarTrigger.addEventListener('click', () => this.toggleCalendar(this.calendar.hidden), {signal});
        this.calendar.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || button.disabled) return;
          if (button.hasAttribute('data-calendar-prev') || button.hasAttribute('data-calendar-next')) {
            this.calendarMonth.setUTCMonth(this.calendarMonth.getUTCMonth() + (button.hasAttribute('data-calendar-next') ? 1 : -1));
            this.renderCalendar();
          } else if (button.dataset.date || button.hasAttribute('data-calendar-clear')) {
            this.refreshAvailability();
            if (button.dataset.date && button.dataset.date < this.dateInput.min) return;
            this.dateInput.value = button.dataset.date || '';
            this.dateInput.dispatchEvent(new Event('change', {bubbles:true}));
            this.toggleCalendar(false);
            this.calendarTrigger.focus();
          } else if (button.hasAttribute('data-calendar-close')) {
            this.toggleCalendar(false);
            this.calendarTrigger.focus();
          }
        }, {signal});
        this.calendar.addEventListener('keydown', event => {
          if (event.key === 'Escape') { this.toggleCalendar(false); this.calendarTrigger.focus(); }
        }, {signal});
      }

      toggleCalendar(open) {
        this.refreshAvailability();
        this.calendar.hidden = !open;
        this.calendarTrigger.setAttribute('aria-expanded', String(open));
        if (open) {
          this.calendarMonth = new Date((this.dateInput.value || this.dateInput.min).slice(0,7) + '-01T12:00:00Z');
          this.renderCalendar();
          this.calendar.querySelector('[data-date]:not(:disabled)')?.focus();
        }
      }

      syncCalendar() {
        if (!this.calendarTrigger) return;
        const label = this.dateInput.value ? this.formatDate(this.dateInput.value) : 'Select a date';
        this.calendarTrigger.textContent = label;
        this.calendarTrigger.setAttribute('aria-label', 'Delivery date: ' + label);
        if (!this.calendar.hidden) this.renderCalendar();
      }

      renderCalendar() {
        if (!this.calendarMonth) return;
        const minMonth = this.dateInput.min.slice(0,7);
        if (this.calendarMonth.toISOString().slice(0,7) < minMonth) this.calendarMonth = new Date(minMonth + '-01T12:00:00Z');
        const year = this.calendarMonth.getUTCFullYear(), month = this.calendarMonth.getUTCMonth();
        this.querySelector('[data-calendar-month]').textContent = new Intl.DateTimeFormat('en', {month:'long',year:'numeric',timeZone:'UTC'}).format(this.calendarMonth);
        this.querySelector('[data-calendar-prev]').disabled = this.calendarMonth.toISOString().slice(0,7) <= minMonth;
        const days = this.querySelector('[data-calendar-days]');
        days.replaceChildren();
        for (let i=0;i<this.calendarMonth.getUTCDay();i++) days.append(document.createElement('span'));
        const count = new Date(Date.UTC(year,month+1,0)).getUTCDate();
        for (let day=1;day<=count;day++) {
          const iso = new Date(Date.UTC(year,month,day)).toISOString().slice(0,10);
          const button = document.createElement('button');
          button.type='button'; button.textContent=String(day); button.dataset.date=iso;
          button.disabled = iso < this.dateInput.min;
          button.setAttribute('aria-label', this.formatDate(iso) + (button.disabled ? ', unavailable' : ''));
          button.setAttribute('aria-pressed', String(iso === this.dateInput.value));
          days.append(button);
        }
      }

      disconnectedCallback() {
        this.buttonObserver?.disconnect();
        this.abortController?.abort();
        this.abortController = null;
      }

      get destination() {
        const fixedDestination = this.destinationInputs.find((input) => input.type === 'hidden');
        if (fixedDestination) return fixedDestination.value;
        return this.destinationInputs.find((input) => input.checked)?.value || '';
      }

      get isGift() {
        return this.giftToggle.getAttribute('aria-checked') === 'true';
      }

      get checkoutButtons() {
        if (this.dataset.productForm === 'true') return Array.from(document.querySelectorAll('button[type="submit"]')).filter(button => button.form === this.form);
        return Array.from(this.form.querySelectorAll('[name="checkout"]'));
      }

      getBeirutNow() {
        const parts = Object.fromEntries(
          new Intl.DateTimeFormat('en-CA', {
            timeZone: 'Asia/Beirut',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23'
          })
            .formatToParts(new Date())
            .filter((part) => part.type !== 'literal')
            .map((part) => [part.type, part.value])
        );
        const hour = Number.parseInt(parts.hour, 10) % 24;
        const minute = Number.parseInt(parts.minute, 10);

        return {
          date: `${parts.year}-${parts.month}-${parts.day}`,
          minutes: (hour * 60) + minute
        };
      }

      addDays(dateString, days) {
        const [year, month, day] = dateString.split('-').map(Number);
        const date = new Date(Date.UTC(year, month - 1, day + days));
        return date.toISOString().slice(0, 10);
      }

      addWorkingDaysExcludingSundays(dateString, days) {
        let result = dateString;
        let addedDays = 0;

        while (addedDays < days) {
          result = this.addDays(result, 1);
          const [year, month, day] = result.split('-').map(Number);
          if (new Date(Date.UTC(year, month - 1, day)).getUTCDay() !== 0) addedDays += 1;
        }

        return result;
      }

      formatDate(dateString) {
        const [year, month, day] = dateString.split('-').map(Number);
        const date = new Date(Date.UTC(year, month - 1, day));

        return new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
          timeZone: 'UTC',
          weekday: 'long',
          month: 'long',
          day: 'numeric'
        }).format(date);
      }

      refreshAvailability() {
        const now = this.getBeirutNow();
        let effectiveLeadDays = this.leadDays;

        if (effectiveLeadDays === 0 && now.minutes >= 1080) effectiveLeadDays = 1;
        if (effectiveLeadDays === 0 && this.dataset.noSundaySameDay === 'true' && new Date(`${now.date}T12:00:00Z`).getUTCDay() === 0) effectiveLeadDays = 1;

        const standardMinDate = this.addDays(now.date, effectiveLeadDays);
        const deskNamePlateMinDate = this.dataset.hasDeskNamePlate === 'true'
          ? this.addWorkingDaysExcludingSundays(now.date, this.leadDays)
          : standardMinDate;
        const minDate = deskNamePlateMinDate > standardMinDate ? deskNamePlateMinDate : standardMinDate;
        this.dateInput.min = minDate;

        if (this.availabilityTitle) {
          this.availabilityTitle.textContent = this.dataset.earliestDateTemplate.replace('__DATE__', this.formatDate(minDate));
        }

        if (this.availabilityHelp) {
          this.availabilityHelp.textContent = effectiveLeadDays === 0
            ? this.dataset.sameDayHelpMessage
            : this.dataset.dateHelpMessage;
        }

        if (this.dateInput.value && this.dateInput.value < minDate) this.dateInput.value = '';

        this.syncCalendar();
        const isSameDay = this.dateInput.value === now.date;
        this.timeOptions.forEach((option) => {
          const startMinutes = Number.parseInt(option.dataset.startMinutes, 10);
          const unavailable = this.destination === 'Lebanon' && isSameDay && startMinutes <= now.minutes;
          option.hidden = unavailable;
          option.disabled = unavailable;
        });

        if (this.timeInput.selectedOptions[0]?.disabled) this.timeInput.value = '';

        if (this.deliveryNote && this.leadDays === 0) {
          this.deliveryNote.textContent = effectiveLeadDays === 0
            ? this.dataset.sameDayMessage
            : this.dataset.leadDayMessage;
        }
      }

      refreshState() {
        const needsSchedule = this.destination === 'Lebanon' && this.dataset.approvalPending !== 'true';
        this.deliverySection.hidden = !needsSchedule;
        const internationalNote = this.querySelector('[data-international-note]');
        if (internationalNote) internationalNote.hidden = this.destination !== 'International' || this.dataset.approvalPending === 'true';
        if (this.dataset.productForm === 'true') {
          const feeDestination = this.form.querySelector('[data-delivery-destination]');
          if (feeDestination) {
            feeDestination.value = this.destination === 'Lebanon' ? 'LB' : 'INT';
            feeDestination.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        this.dateInput.disabled = !needsSchedule;
        this.timeInput.disabled = !needsSchedule;

        if (!needsSchedule) {
          this.dateInput.value = '';
          this.timeInput.value = '';
        }

        this.giftValue.value = this.isGift ? 'Yes' : 'No';
        this.giftFields.hidden = !this.isGift;
        this.giftToggle.setAttribute('aria-expanded', String(this.isGift));
        [this.receiverInput, this.senderInput, this.messageInput].forEach((input) => {
          input.disabled = !this.isGift;
        });

        if (!this.isGift) {
          this.receiverInput.value = '';
          this.senderInput.value = '';
          this.messageInput.value = '';
        }

        this.refreshAvailability();
      }

      isComplete() {
        const hasDestination = Boolean(this.destination);
        const needsSchedule = this.destination === 'Lebanon' && this.dataset.approvalPending !== 'true';
        const dateIsAllowed = !needsSchedule || Boolean(this.dateInput.value && this.dateInput.value >= this.dateInput.min);
        const timeIsAllowed = !needsSchedule || Boolean(this.timeInput.value && !this.timeInput.selectedOptions[0]?.disabled);
        const giftIsComplete = !this.isGift || Boolean(this.receiverInput.value.trim() && this.senderInput.value.trim());

        this.destinationGroup.setAttribute('aria-invalid', String(!hasDestination));
        this.dateInput.setAttribute('aria-invalid', String(!dateIsAllowed));
        this.timeInput.setAttribute('aria-invalid', String(!timeIsAllowed));
        this.receiverInput.setAttribute('aria-invalid', String(this.isGift && !this.receiverInput.value.trim()));
        this.senderInput.setAttribute('aria-invalid', String(this.isGift && !this.senderInput.value.trim()));

        return hasDestination && dateIsAllowed && timeIsAllowed && giftIsComplete && !this.isSaving;
      }

      setCheckoutDisabled(disabled) {
        if (this.dataset.productForm === 'true' && this.dataset.productAvailable !== 'true') disabled = true;
        this.checkoutButtons.forEach((button) => {
          if (disabled) {
            button.setAttribute('aria-disabled', 'true');
          } else {
            button.removeAttribute('aria-disabled');
          }

          if (button.matches('a')) {
            if (disabled) {
              button.setAttribute('tabindex', '-1');
            } else {
              button.removeAttribute('tabindex');
            }
          } else {
            if (button.disabled !== disabled) button.disabled = disabled;
          }
        });
      }

      setStatus(message, state = '') {
        this.status.textContent = message;
        this.status.dataset.state = state;
      }

      updateDisclosureState(complete) {
        if (!this.disclosureState) return;

        this.disclosureState.textContent = complete ? this.dataset.completeLabel : this.dataset.requiredLabel;
        this.disclosureState.dataset.state = complete ? 'complete' : 'required';
      }

      updateCheckoutState(showMessage) {
        const complete = this.isComplete();
        this.setCheckoutDisabled(!complete);
        this.updateDisclosureState(complete);

        if (!complete && showMessage && !this.isSaving) {
          if (!this.destination) {
            this.setStatus(this.dataset.destinationRequiredMessage, 'error');
          } else if (this.isGift && (!this.receiverInput.value.trim() || !this.senderInput.value.trim())) {
            this.setStatus(this.dataset.giftRequiredMessage, 'error');
          } else {
            this.setStatus(this.dataset.deliveryRequiredMessage, 'error');
          }
        } else if (!showMessage && this.status.dataset.state === 'error') {
          this.setStatus('');
        }

        return complete;
      }

      queueSave() {
        const version = ++this.changeVersion;
        this.isSaving = true;
        this.setCheckoutDisabled(true);
        this.updateDisclosureState(false);
        this.setStatus(this.dataset.savingMessage);

        this.saveQueue = this.saveQueue
          .catch(() => undefined)
          .then(() => this.saveCurrentValues())
          .then(() => {
            if (version !== this.changeVersion) return;
            this.isSaving = false;
            const complete = this.updateCheckoutState(false);
            this.setStatus(complete ? this.dataset.savedMessage : '');
          })
          .catch(() => {
            if (version !== this.changeVersion) return;
            this.isSaving = false;
            this.setCheckoutDisabled(true);
            this.setStatus(this.dataset.saveErrorMessage, 'error');
          });
      }

      async saveCurrentValues() {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'Delivery scheduling': '',
              'Delivery destination': this.destination,
              'Delivery date': this.dateInput.value,
              'Delivery time': this.timeInput.value,
              'Is a gift': this.isGift ? 'Yes' : 'No',
              'Receiver name': this.receiverInput.value.trim(),
              'Sender name': this.senderInput.value.trim(),
              'Gift message': this.messageInput.value.trim()
            }
          })
        });

        if (!response.ok) throw new Error('Unable to save order details');
      }

      focusFirstMissing() {
        if (!this.destination) {
          this.destinationInputs[0]?.focus();
        } else if (this.destination === 'Lebanon' && this.dataset.approvalPending !== 'true' && !this.dateInput.value) {
          if (this.calendarTrigger) this.toggleCalendar(true);
          else this.dateInput.focus();
        } else if (this.destination === 'Lebanon' && this.dataset.approvalPending !== 'true' && !this.timeInput.value) {
          this.timeInput.focus();
        } else if (this.isGift && !this.receiverInput.value.trim()) {
          this.receiverInput.focus();
        } else if (this.isGift && !this.senderInput.value.trim()) {
          this.senderInput.focus();
        }
      }

      handleSubmit(event) {
        if (this.dataset.productForm !== 'true' && event.submitter?.name !== 'checkout') return;
        if (this.updateCheckoutState(true)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.disclosure) this.disclosure.open = true;
        this.focusFirstMissing();
      }

    }

    customElements.define('idole-order-details', IdoleOrderDetails);
  }


  if (!customElements.get('idole-cart-delivery-summary')) {
    class IdoleCartDeliverySummary extends customElements.get('idole-order-details') {
      connectedCallback() {
        this.form=this.closest('form');
        this.status=this.querySelector('[role="status"]');
        this.abortController=new AbortController();
        this.validateSummary();
        this.form.addEventListener('submit',event=>{
          if(event.submitter?.name !== 'checkout') return;
          if(!this.validateSummary()) { event.preventDefault(); event.stopImmediatePropagation(); this.querySelector('[data-summary-edit]').focus(); }
        },{capture:true,signal:this.abortController.signal});
      }
      validateSummary() {
        const now=this.getBeirutNow();
        let lead=Number(this.dataset.leadDays)||0;
        if(lead===0 && (now.minutes>=1080 || (this.dataset.noSundaySameDay==='true' && new Date(now.date+'T12:00:00Z').getUTCDay()===0))) lead=1;
        let minimum=this.addDays(now.date,lead);
        if(this.dataset.hasDeskNamePlate==='true') { const working=this.addWorkingDaysExcludingSundays(now.date,lead); if(working>minimum) minimum=working; }
        const starts={'09:00-12:00':540,'12:00-15:00':720,'15:00-18:00':900,'18:00-22:00':1080};
        const destination=this.dataset.destination;
        const validDestination=destination==='Lebanon' || (destination==='International' && this.dataset.allowInternational==='true');
        const validSchedule=this.dataset.approvalPending==='true' || destination==='International' || (this.dataset.date>=minimum && starts[this.dataset.time]!==undefined && (this.dataset.date!==now.date || starts[this.dataset.time]>now.minutes));
        const validGift=this.dataset.gift!=='Yes' || Boolean(this.dataset.receiver.trim() && this.dataset.sender.trim());
        const complete=validDestination && validSchedule && validGift;
        this.checkoutButtons.forEach(button=>{if(button.disabled!==!complete) button.disabled=!complete;});
        this.status.textContent=complete?'':'Please complete or update the delivery details on the product page before checkout.';
        if(complete && destination==='Lebanon' && this.querySelector('[data-summary-date]')) this.querySelector('[data-summary-date]').textContent=this.formatDate(this.dataset.date);
        return complete;
      }
    }
    customElements.define('idole-cart-delivery-summary',IdoleCartDeliverySummary);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["idole-portret-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('idole-portret-options')) {
    const idolePortretState = new Map();

    class IdolePortretOptions extends HTMLElement {
      connectedCallback() {
        const matchingInstances = document.querySelectorAll(
          `idole-portret-options[data-form-id="${CSS.escape(this.dataset.formId)}"]`
        );
        const formInstance = Array.from(matchingInstances).find(
          (instance) => instance.dataset.insideProductForm === 'true'
        );

        if (this.dataset.insideProductForm === 'true') {
          matchingInstances.forEach((instance) => {
            if (instance !== this) instance.remove();
          });
        } else if (formInstance) {
          this.remove();
          return;
        }

        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.fileInput = this.querySelector('[data-idole-portret-file]');
        this.photoStep = this.querySelector('[data-photo-step]');
        this.photoError = this.querySelector('[data-photo-error]');
        this.fileStatus = this.querySelector('[data-file-status]');
        this.uploadSuccess = this.querySelector('[data-upload-success]');
        this.uploadAction = this.querySelector('[data-upload-action]');
        this.uploadLabel = this.querySelector('[data-upload-label]');
        this.textInput = this.querySelector('[data-idole-portret-text]');
        this.notesInput = this.querySelector('textarea[name="properties[Order Notes]"]');
        this.previewInputs = this.querySelectorAll('input[name="properties[Preview Before Production]"]');
        this.wordCount = this.querySelector('[data-word-count]');
        this.wordError = this.querySelector('[data-word-error]');
        this.productionInputs = this.querySelectorAll('[data-idole-portret-production]');
        this.expressProductionInput = this.querySelector('[data-idole-portret-express]');

        this.restoreFileInput();
        this.handleFileChange = () => {
          this.updateFileState();
          this.captureState();
        };
        this.handleFileInvalid = () => this.showPhotoError();

        this.addEventListener('change', (event) => {
          event.stopPropagation();
          this.captureState();
        });
        this.fileInput?.addEventListener('change', this.handleFileChange);
        this.fileInput?.addEventListener('invalid', this.handleFileInvalid);
        this.uploadLabel?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.fileInput?.click();
          }
        });
        this.textInput?.addEventListener('input', () => {
          this.validateWords();
          this.captureState();
        });
        this.notesInput?.addEventListener('input', () => this.captureState());
        this.productionInputs.forEach((input) => {
          input.addEventListener('change', () => this.syncProductionVariant(input));
        });

        this.restoreState();
        this.connectForm();
        this.connectProductionPicker();
      }

      connectProductionPicker() {
        const picker = document.querySelector(`variant-picker[form-id="${CSS.escape(this.dataset.formId)}"]`);

        if (!picker) return;

        this.productionPicker = picker;
        this.prepareNativeProductionOption();
        this.productionObserver = new MutationObserver(() => this.prepareNativeProductionOption());
        this.productionObserver.observe(picker, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.captureState();
        this.fileInput?.removeEventListener('change', this.handleFileChange);
        this.fileInput?.removeEventListener('invalid', this.handleFileInvalid);
        this.productForm?.removeEventListener('submit', this.handleFormSubmit, true);
        this.cacheFileInput();
        this.productionObserver?.disconnect();
      }

      captureState() {
        if (!this.dataset.formId) return;

        idolePortretState.set(this.dataset.formId, {
          file: this.fileInput?.files?.[0] || null,
          fileInput: this.fileInput || null,
          text: this.textInput?.value || '',
          notes: this.notesInput?.value || '',
          preview: Array.from(this.previewInputs || []).find((input) => input.checked)?.value || '',
          production: Array.from(this.productionInputs || []).find((input) => input.checked)?.value || ''
        });
      }

      cacheFileInput() {
        if (!this.fileInput?.files?.length || !document.body?.isConnected) return;

        let cache = document.querySelector(`[data-idole-portret-file-cache="${CSS.escape(this.dataset.formId)}"]`);

        if (!cache) {
          cache = document.createElement('div');
          cache.hidden = true;
          cache.dataset.idolePortretFileCache = this.dataset.formId;
          document.body.append(cache);
        }

        cache.append(this.fileInput);
      }

      restoreFileInput() {
        const state = idolePortretState.get(this.dataset.formId);
        const preservedInput = state?.fileInput;

        if (!preservedInput?.files?.length || !this.fileInput || preservedInput === this.fileInput) return;

        const cache = preservedInput.parentElement;
        this.fileInput.replaceWith(preservedInput);
        preservedInput.setAttribute('form', this.dataset.formId);
        this.fileInput = preservedInput;

        if (cache?.hasAttribute('data-idole-portret-file-cache')) cache.remove();
      }

      restoreState() {
        const state = idolePortretState.get(this.dataset.formId);

        if (!state) {
          this.updateFileState();
          this.validateWords();
          return;
        }

        if (state.file && this.fileInput && !this.fileInput.files?.length) {
          try {
            const transfer = new DataTransfer();
            transfer.items.add(state.file);
            this.fileInput.files = transfer.files;
          } catch (error) {
            console.warn('Unable to restore the selected Portret photo after changing the variant.', error);
          }
        }

        if (this.textInput) this.textInput.value = state.text;
        if (this.notesInput) this.notesInput.value = state.notes;

        this.previewInputs?.forEach((input) => {
          input.checked = input.value === state.preview;
        });
        this.productionInputs?.forEach((input) => {
          input.checked = input.value === state.production;
        });

        this.updateFileState();
        this.validateWords();
      }

      prepareNativeProductionOption() {
        const fieldset = Array.from(this.productionPicker?.querySelectorAll('fieldset') || []).find((group) => {
          const optionName = group.querySelector('legend')?.textContent?.trim().replace(/:$/, '');
          return optionName === 'Production Time';
        });

        if (!fieldset) {
          if (this.expressProductionInput) this.expressProductionInput.disabled = true;
          return;
        }

        if (this.expressProductionInput) this.expressProductionInput.disabled = false;
        fieldset.classList.add('idole-portret-native-production-option');
        const standardLabel = Array.from(fieldset.querySelectorAll('label')).find(label => label.textContent.trim().startsWith('Standard'));
        const standardInput = standardLabel && fieldset.querySelector('input[id="' + CSS.escape(standardLabel.htmlFor) + '"]');
        if (standardInput && !standardInput.checked && !standardInput.disabled) standardInput.click();
        const checkedInput = fieldset.querySelector('input:checked');
        const checkedLabel = checkedInput && fieldset.querySelector(`label[for="${CSS.escape(checkedInput.id)}"]`);
        const checkedValue = checkedLabel?.textContent?.trim();
        const matchingChoice = Array.from(this.productionInputs).find((input) => input.dataset.nativeOptionValue === checkedValue);

        if (matchingChoice && !matchingChoice.checked) matchingChoice.checked = true;
      }

      syncProductionVariant(input) {
        const fieldset = Array.from(this.productionPicker?.querySelectorAll('fieldset') || []).find((group) => {
          const optionName = group.querySelector('legend')?.textContent?.trim().replace(/:$/, '');
          return optionName === 'Production Time';
        });

        if (!fieldset) return;

        const nativeInput = Array.from(fieldset.querySelectorAll('input')).find((candidate) => {
          const label = fieldset.querySelector(`label[for="${CSS.escape(candidate.id)}"]`);
          return label?.textContent?.trim() === input.dataset.nativeOptionValue;
        });

        if (nativeInput && !nativeInput.checked) nativeInput.click();
      }

      syncSelectedVariant(form) {
        const picker = document.querySelector(`variant-picker[form-id="${CSS.escape(this.dataset.formId)}"]`);
        const variantData = picker?.querySelector('script[data-variant]')?.textContent;
        const variantInput = form?.querySelector('input[name="id"]');

        if (!variantData || !variantInput) return;

        try {
          const selectedVariant = JSON.parse(variantData);

          if (!selectedVariant?.id) return;

          variantInput.value = String(selectedVariant.id);
          variantInput.disabled = false;
        } catch (error) {
          console.warn('Unable to synchronize the selected Portret variant.', error);
        }
      }

      moveControlsIntoForm(form) {
        const controls = this.querySelectorAll(`[form="${CSS.escape(this.dataset.formId)}"]`);

        controls.forEach((control) => {
          if (form.contains(control)) return;

          control.removeAttribute('form');
          form.append(control);
        });
      }

      connectForm() {
        const form = document.getElementById(this.dataset.formId);

        if (form) {
          form.setAttribute('enctype', 'multipart/form-data');
          this.productForm = form;
          this.handleFormSubmit ||= (event) => {
            const activeForm = this.productForm;

            if (!activeForm) return;

            const orderDetails = activeForm.querySelector('idole-order-details');
            if (orderDetails && !orderDetails.isComplete()) {
              event.preventDefault(); event.stopImmediatePropagation(); orderDetails.focusFirstMissing(); return;
            }
            this.syncSelectedVariant(activeForm);

            const wordsAreValid = this.validateWords();
            const photoIsValid = Boolean(this.fileInput?.files?.length);

            if (!photoIsValid) this.showPhotoError();

            if (!wordsAreValid || !photoIsValid) {
              event.preventDefault();
              event.stopImmediatePropagation();
              if (!photoIsValid) this.uploadLabel?.focus();
              else this.textInput?.focus();
              return;
            }

            event.preventDefault();
            event.stopImmediatePropagation();
            this.moveControlsIntoForm(activeForm);
            HTMLFormElement.prototype.submit.call(activeForm);
          };
          form.addEventListener('submit', this.handleFormSubmit, true);
          return;
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.connectForm(), { once: true });
        } else {
          requestAnimationFrame(() => this.connectForm());
        }
      }

      updateFileState() {
        const file = this.fileInput?.files?.[0];
        this.fileStatus.textContent = file ? file.name : this.dataset.noFile;
        this.uploadAction.textContent = file ? this.dataset.replacePhoto : this.dataset.choosePhoto;
        this.photoStep?.classList.toggle('has-file', Boolean(file));
        this.photoStep?.classList.remove('has-error');
        if (this.uploadSuccess) this.uploadSuccess.hidden = !file;
        this.photoError.textContent = '';
      }

      showPhotoError() {
        this.photoStep?.classList.add('has-error');
        this.photoError.textContent = this.dataset.photoRequired;
      }

      validateWords() {
        const value = this.textInput?.value.trim() || '';
        const count = value ? value.split(/\s+/u).length : 0;
        const isValid = count <= 3;
        this.wordCount.textContent = this.dataset.wordTemplate.replace('__COUNT__', String(count));
        this.textInput?.setCustomValidity(isValid ? '' : this.dataset.wordError);
        this.wordError.textContent = isValid ? '' : this.dataset.wordError;
        return isValid;
      }
    }

    customElements.define('idole-portret-options', IdolePortretOptions);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["idole-product-delivery-summary"] && !Shopify.designMode) return;
  try {
    (() => {
    const selections = new Map();
    const initialize = root => {
      if (root.dataset.deliveryReady) return;
      root.dataset.deliveryReady = 'true';
      const find = selector => root.querySelector(selector);
      const destination = find('[data-delivery-destination]');
      const area = find('[data-delivery-area]');
      const country = find('[data-delivery-country]');
      const saved = selections.get(root.dataset.productId);
      if (saved) {destination.value=saved.destination; area.selectedIndex=saved.area; country.selectedIndex=saved.country;}
      const worldwide = root.dataset.worldwide === 'true';
      const variants = JSON.parse(find('[data-delivery-variants]').textContent);
      const rates = JSON.parse(find('[data-delivery-rates]').textContent);
      const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:'USD'}).format(value) + ' USD';
      const productScope = root.closest('product-info') || root.closest('.shopify-section') || root.parentElement;
      let previousItem = '';
      const update = () => {
        const abroad = destination.value === 'INT';
        find('[data-delivery-area-field]').hidden = abroad;
        find('[data-delivery-country-field]').hidden = !abroad || !worldwide;
        find('[data-delivery-local-timing]').hidden = abroad;
        const result = find('.idole-delivery-check__result');
        result.classList.remove('idole-delivery-check__result--warning');
        let title = root.dataset.selectArea;
        let detail = root.dataset.localNote;
        if (!abroad) {
          const amount = Number(area.value);
          if (area.value) title = root.dataset.estimate + ': ' + money(amount);
        } else if (!worldwide) {
          title = root.dataset.blockedTitle;
          detail = root.dataset.blockedDetail;
          result.classList.add('idole-delivery-check__result--warning');
        } else {
          title = root.dataset.selectCountry;
          detail = (root.dataset.preparation ? root.dataset.preparation + ' ' : '') + root.dataset.worldwideTiming;
          if (country.value) {
            const variantId = productScope.querySelector('form[action*="/cart/add"] [name="id"]')?.value || root.dataset.variantId;
            const quantityInput = productScope.querySelector('[name="quantity"]');
            const quantity = Math.max(1,Number(quantityInput?.value)||1);
            const variant = variants.find(item => String(item.id) === String(variantId));
            const weight = Number(variant?.weight) * quantity;
            const zoneRates = rates[country.value];
            const bracket = weight > 0 ? zoneRates?.find(row => weight >= row[0] && weight <= row[1]) : zoneRates?.[0];
            if (bracket) {
              title = (weight > 0 ? root.dataset.dhl : root.dataset.starting) + ': ' + money(bracket[2]);
              detail = (weight > 0 ? root.dataset.internationalNote : root.dataset.startingNote) + ' ' + (root.dataset.preparation ? root.dataset.preparation + ' ' : '') + root.dataset.worldwideTiming;
              if (country.selectedOptions[0]?.dataset.us) detail += ' ' + root.dataset.territories;
            } else {
              title = root.dataset.unavailableTitle;
              detail = root.dataset.unavailableDetail;
              result.classList.add('idole-delivery-check__result--warning');
            }
          }
        }
        find('[data-delivery-result-title]').textContent = title;
        find('[data-delivery-result-detail]').textContent = detail;
        selections.set(root.dataset.productId,{destination:destination.value,area:area.selectedIndex,country:country.selectedIndex});
      };
      root.addEventListener('change',update);
      productScope.addEventListener('input', event => {if (event.target.matches('[name="quantity"]')) update();});
      productScope.addEventListener('change', update);
      const timer = setInterval(() => {
        if (!root.isConnected) {clearInterval(timer); return;}
        const item = (productScope.querySelector('form[action*="/cart/add"] [name="id"]')?.value || root.dataset.variantId) + ':' + (productScope.querySelector('[name="quantity"]')?.value || 1);
        if (item !== previousItem) {previousItem=item; update();}
      },750);
      update();
    };
    const mount = scope => scope.querySelectorAll('[data-idole-delivery-check]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>mount(document)); else mount(document);
    document.addEventListener('shopify:section:load',event=>mount(event.target));
    new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1){if(node.matches('[data-idole-delivery-check]')) initialize(node); mount(node);}}))).observe(document.documentElement,{childList:true,subtree:true});
  })();
  } catch(e) { console.error(e); }
})();

})();
